import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RevealOnScrollDirective } from '../../reveal-on-scroll.directive';
import { GallerySectionService } from './gallery-section.service';

@Component({
  selector: 'app-gallery-section',
  standalone: true,
  imports: [CommonModule, RevealOnScrollDirective],
  templateUrl: './gallery-section.component.html',
  styleUrl: './gallery-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GallerySectionComponent {
  get content() {
    return this.galleryService.content;
  }

  constructor(private readonly galleryService: GallerySectionService) {}
}
